export default __webpack_public_path__ + "static/media/icons.c30b6475.svg";